import { useEffect, useState } from 'react';
import axios from 'axios';

// Plain controlled <select> for Clasification, used instead of the shared
// Selector.jsx component specifically for this field. Selector.jsx
// auto-selects the sole row whenever its fetched list has exactly one item
// - and /api/clasifications currently has exactly 1 ("Text answer", the
// legacy per-answer-option classification used by conversations/
// ModalInterface.jsx, an unrelated feature this table is shared with, so
// seeding it with more course-flavored values isn't safe either). That
// auto-select forced "Text answer" onto every Course form's classification
// field even when untouched, permanently (and wrongly) marking
// CourseEditForm/CourseCreateModal as dirty on open. This component has no
// per-list-size special-casing, so it can't reproduce that.
export default function ClassificationSelect({ value, onChange, className }) {
   const [options, setOptions] = useState([]);

   useEffect(() => {
      axios.get('/api/clasifications', { withCredentials: true })
         .then(response => setOptions(Array.isArray(response.data) ? response.data : []))
         .catch(() => setOptions([]));
   }, []);

   return (
      <select className={className} value={value || ''} onChange={e => onChange(e.target.value)}>
         <option value=''>Не обрано</option>
         {options.map(opt => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
      </select>
   );
}
